<div class="why-unipay" #sectionElement>
  <app-container class="why-unipay__container">
    <div class="why-unipay__header">
      <h2 class="why-unipay__title">¿Por qué usar Unipay?</h2>
      <p class="why-unipay__subtitle">Conoce los beneficios pensados en ti</p>
    </div>

    <div class="why-unipay__grid">
      <!-- Beneficio 1 -->
      <div class="why-unipay__card">
        <div class="why-unipay__icon-container">
          <div class="why-unipay__icon-wrapper">
         <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-mobile.png" alt="100% digital">
          </div>
        </div>
        <h3 class="why-unipay__card-title">100% Digital</h3>
        <p class="why-unipay__card-description">
       <b>Más simple, más seguro. </b>
       Realiza tus pagos sólo con tu huella
        </p>
      </div>

      <!-- Beneficio 2 -->
      <div class="why-unipay__card">
        <div class="why-unipay__icon-container">
          <div class="why-unipay__icon-wrapper">
           <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-descuento.png" alt="descuentos">
          </div>
        </div>
        <h3 class="why-unipay__card-title">Descuentos exclusivos</h3>
         <p class="why-unipay__card-description">
      <b>Ahorra más con Unipay</b> en Unimarc, Alvi y Super 10
        </p>
      </div>

      <!-- Beneficio 3 -->
      <div class="why-unipay__card">
        <div class="why-unipay__icon-container">
          <div class="why-unipay__icon-wrapper">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-dinero.png" alt="Avances en efectivo">
          </div>
        </div>
        <h3 class="why-unipay__card-title">Avances en efectivo</h3>
        <p class="why-unipay__card-description">
          Solicita dinero
          <b>rápido y sin papeleo.</b> Avances y super avances
        </p>
      </div>

      <!-- Beneficio 4 -->
      <div class="why-unipay__card">
        <div class="why-unipay__icon-container">
          <div class="why-unipay__icon-wrapper">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-seguridad.png" alt="Seguridad">
          </div>
        </div>
        <h3 class="why-unipay__card-title">Seguridad total</h3>
        <p class="why-unipay__card-description">
          Con Unipay, al
          <b>pagar con huella</b> siempre es más seguro
        </p>
      </div>
    </div>
  </app-container>
</div>
